import "regenerator-runtime/runtime";

import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ReactElement } from "react";

import "./index.css";

// Context Provider
import {
  MaterialUIControllerProvider,
  FormVaridationProvider,
} from "./context";

import { createTranslation } from "@chronospark/shared";
const { TranslationProvider } = createTranslation();

import { SessionProvider } from "./context/SessionContext";
import { PaywallProvider } from './context/PaywallContext';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://7f2839935b58af78168b3ffae4ae9ba8@o4511464565702656.ingest.us.sentry.io/4511464567799808",
  
  // ローカル開発環境(npm run dev)ではSentryを無効化する
  enabled: import.meta.env.PROD,
  
  // 現在の環境(production等)をSentryに伝える
  environment: import.meta.env.MODE,
  
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // パフォーマンス監視の割合（10%のみ送信）
  tracesSampleRate: 0.1,
  
  // セッションリプレイの割合（エラー時のみ録画）
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  // 無視するエラー（ノイズフィルター）
  ignoreErrors: [
    "Network Error",
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "Non-Error promise rejection captured",
  ],
});

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const root = createRoot(document.getElementById("root"));

const AppElement: ReactElement = (
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <TranslationProvider>
        <FormVaridationProvider>
          <SessionProvider>
            <PaywallProvider>
              <App />
            </PaywallProvider>
          </SessionProvider>
        </FormVaridationProvider>
      </TranslationProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);

// @ts-ignore
root.render(AppElement);
